<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import Label from '$provider/constants/Label';
  import Action from './partials/Action.svelte';
  import type { ProfileImportBanner } from '$provider/models/profileImportBanner/ProfileImportBanner';

  interface Props {
    loading?: boolean;
    option?: ProfileImportBanner | null;
    oncancel?: () => void;
    onclose?: () => void;
    onbanneraction?: (payload: { actionLabel: string }) => void;
  }

  let { loading = false, option = null, oncancel, onclose, onbanneraction }: Props = $props();

  const onClickCancel = (): void => {
    oncancel?.();
  };

  const onClickClose = (): void => {
    onclose?.();
  };
</script>

{#if option}
  <div class="comp-profile-import-banner {option.type}" data-cy="profile-import-banner">
    <div class="banner-content">
      <div class="left-content">
        <div class="icon"><Icon value={option.bannerIcon} fontSize="24px" size="24px" /></div>
        <div class="disclaimer" data-cy="caqh-banner-label">
          {@html option.label}
          {#if option.showCancel}(<button
              data-cy="cancel-merge-btn"
              onclick={onClickCancel}
              class="link-action"
            >
              {Label.Cancel}
            </button>)
          {/if}
        </div>
      </div>
      <div class="right-content">
        {#if option.subActionLabel}
          <div class="merge-action">
            <Action actionLabel={option.subActionLabel} {loading} {onbanneraction} />
          </div>
        {/if}

        <Action
          actionLabel={option.actionLabel}
          actionIcon={option.actionIcon}
          {loading}
          {onbanneraction}
        />
        {#if option.closable}
          <Icon
            type={IconType.Button}
            value="icon-x"
            fontSize="18px"
            size="18px"
            onclick={onClickClose}
          />
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .comp-profile-import-banner {
    border-radius: 6px;
    box-shadow: 1px 10px 15px -10px rgba(0, 0, 0, 0.1);
    background-color: var(--light-blue);
    padding: 8px;
  }
  .comp-profile-import-banner.info {
    background-color: var(--light-blue);
  }
  .comp-profile-import-banner.warn {
    background-color: var(--yellow-light);
  }
  .comp-profile-import-banner.error {
    background-color: #f8d4d4;
  }
  .banner-content {
    display: flex;
    justify-content: space-between;
  }
  .left-content {
    display: inline-flex;
    align-items: center;
  }
  .left-content .icon {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
  }
  .left-content .disclaimer .link-action {
    font-weight: 400;
    color: var(--blue);
    cursor: pointer;
  }
  .right-content {
    display: inline-flex;
    align-items: center;
  }

  .merge-action {
    border-right: 1px solid;
    padding: 0 10px;
  }

  :global(.merge-action button) {
    padding: 0px !important;
  }
</style>
